import { useCallback } from 'react';

import { useDispatch } from 'react-redux';

import { addMembershipToCart } from '../../actions/checkout';
import { MembershipActionLocation } from '../../constants/checkout';

export function useAddMembershipFromCartDrawer() {
  const dispatch = useDispatch();
  const addMembershipFromCartDrawer = useCallback(() => {
    dispatch(
      addMembershipToCart({
        location: MembershipActionLocation.MINI_CART,
      })
    );
  }, [dispatch]);
  return addMembershipFromCartDrawer;
}
